import React, { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

import "./styles/navBar.css";

const NavBar = (props) => {
	const { active } = props;
	const { pathname } = useLocation();
	const navBackgroundRef = useRef(null);
	const activeLinkRef = useRef(null);
	const currentPath = pathname.replace(/\/+$/, "") || "/";

	const pathSections = [
		{ path: "/", section: "home" },
		{ path: "/about", section: "about" },
		{ path: "/projects", section: "projects" },
		{ path: "/media", section: "projects" },
		{ path: "/articles", section: "store" },
		{ path: "/contact", section: "booking" },
		{ path: "/booking/success", section: "booking" },
		{ path: "/events", section: "events" },
		{ path: "/keynotes", section: "keynotes" },
		{ path: "/blog", section: "blog" },
	];
	const routeSection = pathSections.find(({ path }) =>
		path === "/" ? currentPath === path : currentPath === path || currentPath.startsWith(`${path}/`)
	)?.section;
	const activeAliases = {
		media: "projects",
		articles: "store",
	};
	const activeSection = routeSection || activeAliases[active] || active;
	const navItems = [
		{ section: "home", path: "/", label: "Home" },
		{ section: "about", path: "/about", label: "About" },
		{ section: "projects", path: "/projects", label: "Media" },
		{ section: "store", path: "/articles", label: "Store" },
		{ section: "booking", path: "/contact", label: "Book" },
		{ section: "events", path: "/events", label: "Events" },
		{ section: "keynotes", path: "/keynotes", label: "Keynotes" },
		{ section: "blog", path: "/blog", label: "Blogs" },
	];

	useEffect(() => {
		const container = navBackgroundRef.current;
		const link = activeLinkRef.current;
		if (!container || !link || container.scrollWidth <= container.clientWidth) return;
		const containerRect = container.getBoundingClientRect();
		const linkRect = link.getBoundingClientRect();
		const nextScrollLeft = container.scrollLeft + linkRect.left - containerRect.left - (container.clientWidth - linkRect.width) / 2;
		container.scrollTo({ left: nextScrollLeft, behavior: "smooth" });
	}, [activeSection]);

	return (
		<div className="nav-container">
			<nav className="navbar" aria-label="Main navigation">
				<div className="nav-background" ref={navBackgroundRef}>
					<ul className="nav-list">
						{navItems.map((item) => {
							const isActive = activeSection === item.section;
							return (
								<li className={`nav-item${isActive ? " active" : ""}`} key={item.section}>
									<Link
										to={item.path}
										ref={isActive ? activeLinkRef : null}
										aria-current={isActive ? "page" : undefined}
									>
										{item.label}
									</Link>
								</li>
							);
						})}
					</ul>
				</div>
			</nav>
		</div>
	);
};

export default NavBar;